// @flow

import React from "react"
import Layout from "../components/layout"
import { Link, graphql } from "gatsby"

export default ({
    data: {
        allMarkdownRemark: { group },
        site: {
            siteMetadata: { description },
        },
    },
}: {
    data: { allMarkdownRemark: Object, site: Object },
}) => (
    <Layout title="All tags" description={description}>
        <h2 style={{ marginTop: 25, marginBottom: 50 }}>All tags</h2>
        <ul>
            {group.map((tag) => (
                <li key={tag.fieldValue}>
                    <Link to={`/tags/${tag.fieldValue}`}>
                        {tag.fieldValue} ({tag.totalCount})
                    </Link>
                </li>
            ))}
        </ul>
    </Layout>
)

export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                description
            }
        }
        allMarkdownRemark(limit: 2000) {
            group(field: frontmatter___tags) {
                fieldValue
                totalCount
            }
        }
    }
`
